import { components } from './theme/componentTokens';

/**
 * Full-screen dim for menus portalled to <body> (ActionMenu, UserAccountMenu).
 *
 * ABSOLUTE, never fixed (safari-top-and-centering, 2026-09-27): Safari 26
 * dropped `theme-color` and tints its status strip from the FIXED/STICKY layer
 * hit-tested at the top edge — a fixed dim got sampled and the strip stayed
 * stuck grey after the menu closed (founder device report: every modal opened
 * from the account menu, and logout). An absolute layer is ignored for tinting.
 * <body> never scrolls (the app scrolls inside AppShell) and is never
 * transformed (the push-drawer transform lives on #root), so absolute +
 * max(dvh, lvh) covers exactly what a fixed inset:0 layer did.
 */
export const BODY_DIM_LAYER = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: 'max(100dvh, 100lvh)',
  backgroundColor: components.overlay.scrimSoft,
};
